import React, { useEffect } from 'react';
import { useAnalyticsConsent } from '../../hooks/use-analytics-consent';
import { useLocaleDetails } from '../../hooks/use-locale-details';
import { FirstTouchAttributionService } from '../../services/analytics/first-touch-attribution.service';

const FirstTouchAttribution: React.FC = () => {
    const { analyticsConsent, analyticsConsentRequired } = useAnalyticsConsent();
    const { localeCode } = useLocaleDetails();

    useEffect(() => {
        if (!analyticsConsentRequired || analyticsConsent === 'accepted') FirstTouchAttributionService.capture(localeCode);
    }, [analyticsConsent, analyticsConsentRequired, localeCode]);

    return null;
};

export default FirstTouchAttribution;
